import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { PaymentsIncomingWireTable } from '../../../../../../../../../../features/payments/incoming-wire/payments-incoming-wire-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinancePayments,
      label: 'Incoming Wire',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinancePayments>,
  head: () => getPageHead('Incoming ACH Payments'),
  component: PaymentsIncomingWireList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingFinancePayments}
    />
  );
}

function PaymentsIncomingWireList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <PaymentsIncomingWireTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
